class ZoomGallery extends HTMLElement {
  constructor() {
    super();
    this.activeVideos = [];

    this.fauxPrev = this.querySelector(".swiper-faux-controls [data-prev]");
    this.fauxNext = this.querySelector(".swiper-faux-controls [data-next]");

    this.zoomInBtn = this.querySelector("[data-zoom-in]");
    this.zoomOutBtn = this.querySelector("[data-zoom-out]");
    this.maxZoom = 6;

    window.loadSwiper.then(({ Swiper, EffectFade, Thumbs }) => {
      this.Swiper = Swiper;
      this.EffectFade = EffectFade;
      this.Thumbs = Thumbs;

      this._initThumbsCarousel();
      this._initCarousel();
    });
  }

  _initThumbsCarousel() {
    const swiperParams = {
      modules: [this.Thumbs],
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 400,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      keyboard: {
        enabled: true,
      },
    };

    this.thumbsSwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__thumbnails-list-wrapper`),
      swiperParams,
    );
  }

  _initCarousel() {
    const swiperParams = {
      slidesPerView: "auto",
      initialSlide: this.dataset.preselectMediaIndex,
      speed: 400,
      watchSlidesProgress: true,
      zoom: {
        maxRatio: this.maxZoom,
        minRatio: 1,
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      init: false,
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.nextZoomRatio = this.gallerySwiper.zoom.scale + 1;

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    this.gallerySwiper.on("zoomChange", () => {
      setTimeout(() => {
        console.log(this.gallerySwiper.zoom.scale);
        if (this.gallerySwiper.zoom.scale >= this.maxZoom) {
          this.zoomInBtn.classList.add("grey-out");
        } else {
          this.zoomInBtn.classList.remove("grey-out");
        }

        if (this.gallerySwiper.zoom.scale <= 1) {
          this.zoomOutBtn.classList.add("grey-out");
        } else {
          this.zoomOutBtn.classList.remove("grey-out");
        }
      }, 100);
    });

    // Default toggles on double click so manually toggle on click
    this.gallerySwiper.on("click", () => {
      if (this.gallerySwiper.zoom.scale < this.maxZoom) {
        this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
      } else {
        this.gallerySwiper.zoom.out();
      }
    });

    this.zoomInBtn.addEventListener("click", () => {
      if (this.gallerySwiper.zoom.scale > this.maxZoom) return;
      this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
    });

    this.zoomOutBtn.addEventListener("click", () => {
      this.gallerySwiper.zoom.out();
    });

    this.fauxPrev.addEventListener("click", () => {
      this.gallerySwiper.slidePrev();
    });

    this.fauxNext.addEventListener("click", () => {
      this.gallerySwiper.slideNext();
    });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("zoom-gallery")) {
  customElements.define("zoom-gallery", ZoomGallery);
}
